var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * PinFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPinFilled extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon-pin-filled', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.2117 1.02141C15.5563 0.97442 15.907 1.00501 16.2383 1.11094C16.5695 1.21687 16.8729 1.39547 17.1263 1.63368L17.1435 1.65039L22.1396 6.6465L22.1563 6.66373C22.3946 6.91711 22.5731 7.22051 22.6791 7.55176C22.7849 7.883 22.8156 8.23374 22.7686 8.57832C22.7216 8.92291 22.5982 9.25264 22.4075 9.54344C22.2167 9.83422 21.9635 10.0787 21.666 10.2591L21.6536 10.2666L17.6307 12.6047L16.0583 19.1907L16.0551 19.2044C15.9809 19.4925 15.8334 19.7561 15.6273 19.9705C15.4212 20.1848 15.1633 20.3423 14.8785 20.4277C14.5937 20.5132 14.2916 20.5238 14.0016 20.4582C13.7115 20.3927 13.4433 20.2534 13.2228 20.054C13.213 20.0452 13.2035 20.0361 13.1942 20.0268L3.61326 10.4302C3.40379 10.2134 3.25532 9.94506 3.18277 9.65242C3.11024 9.3598 3.11625 9.05319 3.20024 8.76364C3.28421 8.47408 3.44315 8.21184 3.66098 8.00342C3.87884 7.795 4.14785 7.64779 4.44083 7.57671L4.45513 7.57324L11.12 6.089L13.5309 2.12395C13.7113 1.82693 13.956 1.57312 14.2466 1.38253C14.5374 1.19178 14.8671 1.0684 15.2117 1.02141ZM1.34189 20.7982L6.28248 15.8575L7.93198 17.5096L2.99275 22.4491C2.53689 22.9049 1.79778 22.9049 1.34191 22.4491C0.886038 21.9932 0.886029 21.254 1.34189 20.7982Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconPinFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPinFilled.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconPinFilled.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconPinFilled.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-pin-filled') === undefined) {
    customElements.define('cat-icon-pin-filled', BlocksIconPinFilled);
}
